/**
Project: Voice Panel (c)
Title: Numbers Import
Description: Component to display the Import the numbers.
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Flex,
  Dialog,
  Divider,
  Text,
  Menu,
  tabListBehavior,
  Button,
  FormLabel,
  Input,
  LinkIcon,
  CloseIcon,
  Image,
} from "@fluentui/react-northstar";
import axios from "axios";
import IntlUtil from "../../../../core/helpers/intl-util";
import {
  showPageWaitDialog,
  hidePageWaitDialog,
} from "../../common/actions/general-actions";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import { AppConfigProps } from "../../../../core/settings/app-config";
import ResponseUtil from "../../../../core/helpers/response-util";
import { Grid, Row, Col } from "react-flexbox-grid";
import {
  uploadInventory,
  uploadDevices,
  getDialCodeByCountry,
} from "../actions/number-inventory-actions";
import { manageError } from "../../../../core/actions/common-actions";
import AlertErrorMessage from "../../common/helpers/alert-error-message";
import SippioVoicePanelNumberImport from "../../../../../assets/images/illustrations/Subscriber-Numbers-CSV-Import-Instructions.png";
import SippioVoicePanelDeviceImport from "../../../../../assets/images/illustrations/Subscriber-Numbers-Devices-CSV-Import-Instructions.png";
import { getInventoryFileData, getDeviceFileData } from "../actions/number-inventory-actions";
import { numberInventory, numberDevices } from "../settings/numbers-devices-data";
import PageUtil from "../../../../core/helpers/page-util";

class NumberImport extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_number_inventory = "vpa_number_inventory";
  constructor(props) {
    super(props);
    this.showChooseFile = React.createRef();
    this.state = {
      selectedIndex: 0,
      importedData: null,
      attachment: null,
      showAlert: false,
      showImageNumberDialog: false,
      showImageDeviceDialog: false,
      errorMessage: null,
      errorDetails: null,
      successMessage: null,
      numberList: [],
      deviceList: [],
    };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  isValidFileType = async (file) => {
    let isValid = false;
    if (file) {
      const fileName = file.name;
      if (fileName && fileName.length > 0) {
        VoiceAdminConstants.INVENTORY.FILE_TYPES.forEach((fileType) => {
          if (
            fileName
              .substr(fileName.length - fileType.length, fileType.length)
              .toLowerCase() === fileType.toLowerCase()
          ) {
            isValid = true;
          }
        });
      }
    }
    return isValid;
  };


  exportInventory = async () => {
    await this.setStateAsync({ exportInfoMessage: null });
    const csvFileData = await getInventoryFileData(
      this._intl_ns_vpa_number_inventory,
      numberInventory
    );
    const csvFileName = "inventory-numbers-sample-data.csv";
    await PageUtil.downloadCSVFile(csvFileName, csvFileData);
    await this.setStateAsync({
      exportInfoMessage: IntlUtil.getText(
        this._intl_ns_vpa_number_inventory,
        "notification.info.exportNumberInventory"
      )
    });
  };

  exportdevice = async () => {
    await this.setStateAsync({ exportInfoMessage: null });
    const csvFileData = await getDeviceFileData(
      this.props.countryRecord,
      this._intl_ns_vpa_number_inventory,
      numberDevices
    );
    const csvFileName = "inventory-numbers-devices-sample-data.csv";
    await PageUtil.downloadCSVFile(csvFileName, csvFileData);
    await this.setStateAsync({
      exportInfoMessage: IntlUtil.getText(
        this._intl_ns_vpa_number_inventory,
        "notification.info.exportDeviceInventory"
      )
    });
  }


  numbersCsvJsonConvert = async (dataString) => {
    const dataStringLines = dataString.split(/\r\n|\n/);
    const headers = dataStringLines[0].split(
      /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
    );
    const list = [];
    let headerChange = VoiceAdminConstants.INVENTORY.NUMBER_JSON_KEYS;
    let tableHeaderColumns = VoiceAdminConstants.INVENTORY.NUMBER_COLUMNS;
    let columnOrder = [];
    let columnRecordsCount = [];
    if (headers.length > 0) {
      let defaultHeaders = [];
      await headers.forEach(header => {
        if (header !== "ErrorMessage" && header !== "UpdateStatus") {
          defaultHeaders.push(header);
        }
      });
      if (defaultHeaders.length > 0) {
        if (defaultHeaders.length === tableHeaderColumns.length) {
          for (let i in tableHeaderColumns) {
            if (headers[i] !== tableHeaderColumns[i]) {
              columnOrder.push(i);
            }
            if (tableHeaderColumns.length - headers.length > 0) {
              columnRecordsCount.push(false);
              break;
            }
          }
          if (columnOrder.length < 1 && columnRecordsCount.length < 1) {
            for (let i = 1; i < dataStringLines.length; i++) {
              const row = dataStringLines[i].split(
                /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
              );
              if (headers && row.length === headers.length) {
                const obj = {};
                for (let j = 0; j < headers.length; j++) {
                  let d = row[j];
                  if (d.length > 0) {
                    if (d[0] === '"') d = d.substring(1, d.length - 1);
                    if (d[d.length - 1] === '"') d = d.substring(d.length - 2, 1);
                  }
                  if (headerChange[j]) {
                    obj[headerChange[j]] = d;
                  }
                }
                // remove the blank rows
                if (Object.values(obj).filter((x) => x).length > 0) {
                  list.push(obj);
                }
              }
            }
            if (list && list.length > 0) {
              let numbersData = [];
              list.forEach((number) => {
                let numberPrefix = getDialCodeByCountry(
                  this.props.countryStatesData,
                  number?.numberCountryName
                );
                const numberObj = {
                  ...number,
                  phoneNumber:
                    number?.phoneNumber &&
                      number?.phoneNumber.length > 0 &&
                      numberPrefix &&
                      numberPrefix.length > 0
                      ? numberPrefix + number?.phoneNumber
                      : number?.phoneNumber,
                };
                numbersData.push(numberObj);
              });
              if (
                list.length <= VoiceAdminConstants.INVENTORY.NUMBER_FILE_MAXIMUM_ROWS
              ) {
                this.setState({ numberList: numbersData });
              } else {
                await this.setState({ attachment: null, numberList: [] });
                await this.setStateAsync({
                  errorMessage: IntlUtil.getText(
                    this._intl_ns_vpa_number_inventory,
                    "notification.error.numbersFileMaxRowsInvalid"
                  ),
                  showAlert: true,
                });
              }
            } else {
              await this.setState({ attachment: null, numberList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.NumberCSVFileEmpty"
                ),
                showAlert: true,
              });
            }
          } else {
            if (columnRecordsCount.length >= 1) {
              await this.setState({ attachment: null, numberList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.numberCSVColumnRecordsCount"
                ),
                showAlert: true,
              });
            } else if (columnOrder.length >= 1) {
              await this.setState({ attachment: null, numberList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.numberCSVColumnOrder"
                ),
                showAlert: true,
              });
            } else {
              await this.setState({ attachment: null, numberList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.numberImportFailed"
                ),
                showAlert: true,
              });
            }
          }
        } else {
          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.error.numberCSVColumnRecordsCount"
            ),
            showAlert: true,
          });
        }
      }
    }
  };

  handleFileUploadClick = async (e) => {
    this.showChooseFile.current.click();
  };

  clearAlert = async () => {
    await this.setStateAsync({
      showAlert: false,
      errorMessage: null,
      errorDetails: null,
      successMessage: null,
    });
  };

  // numbers
  importInventory = async (e) => {
    await this.clearAlert();
    if (e && e.target.files && e.target.files.length === 1) {
      const file = e.target.files[0];
      e.target.value = "";
      if (file) {
        const isValidFileType = await this.isValidFileType(file);
        if (isValidFileType === true) {
          const fileObj = { fileName: file.name, fileType: file.type };
          await this.setStateAsync({ attachment: fileObj });
          const reader = new FileReader();
          reader.onload = async (evt) => {
            const fileInput = evt.target.result;
            this.numbersCsvJsonConvert(fileInput);
          };
          reader.readAsBinaryString(file);
        } else {
          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.error.numberinvalidFile"
            ),
            showAlert: true,
          });
        }
      }
    }
  };

  // devices
  importDevices = async (e) => {
    if (e && e.target.files && e.target.files.length === 1) {
      const file = e.target.files[0];
      e.target.value = "";
      if (file) {
        const isValidFileType = await this.isValidFileType(file);
        if (isValidFileType === true) {
          const fileObj = { fileName: file.name, fileType: file.type };
          await this.setStateAsync({ attachment: fileObj });
          const reader = new FileReader();
          reader.onload = async (evt) => {
            const fileInput = evt.target.result;
            this.devicesCsvJsonConvert(fileInput);
          };
          reader.readAsBinaryString(file);
        } else {
          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.error.numberinvalidFile"
            ),
            showAlert: true,
          });
        }
      }
    }
  };

  renderNumberImageDialog = () => {
    return (
      <Dialog
        className="vpa-dialog-image"
        headerAction={{
          icon: <CloseIcon />,
          title: "Close",
          onClick: () => this.setState({ showImageNumberDialog: false }),
        }}
        open={this.state.showImageNumberDialog}
        content={
          <Flex className="vpa-image-container">
            <Image aria-hidden="true" src={SippioVoicePanelNumberImport} />
          </Flex>
        }
      />
    );
  };

  renderDeciceImageDialog = () => {
    return (
      <Dialog
        className="vpa-dialog-image v-height-image"
        headerAction={{
          icon: <CloseIcon />,
          title: "Close",
          onClick: () => this.setState({ showImageDeviceDialog: false }),
        }}
        open={this.state.showImageDeviceDialog}
        content={
          <Flex className="vpa-image-container">
            <Image aria-hidden="true" src={SippioVoicePanelDeviceImport} />
          </Flex>
        }
      />
    );
  };

  devicesCsvJsonConvert = async (dataString) => {
    const dataStringLines = dataString.split(/\r\n|\n/);
    const headers = dataStringLines[0].split(
      /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
    );
    const list = [];
    let tableHeaderColumns = VoiceAdminConstants.INVENTORY.DEVICE_COLUMNS;
    let headerChange = VoiceAdminConstants.INVENTORY.DEVICE_JSON_KEYS;
    let columnOrder = [];
    let columnRecordsCount = [];
    if (headers.length > 0) {
      let defaultHeaders = [];
      await headers.forEach(header => {
        if (header !== "ErrorMessage" && header !== "UpdateStatus") {
          defaultHeaders.push(header);
        }
      });
      if (defaultHeaders.length > 0) {
        if (defaultHeaders.length === tableHeaderColumns.length) {
          for (let i in tableHeaderColumns) {
            if (headers[i] !== tableHeaderColumns[i]) {
              columnOrder.push(i);
            }
            if (tableHeaderColumns.length - headers.length > 0) {
              columnRecordsCount.push(false);
              break;
            }
          }
          if (columnOrder.length < 1 && columnRecordsCount.length < 1) {
            for (let i = 1; i < dataStringLines.length; i++) {
              const row = dataStringLines[i].split(
                /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
              );
              if (headers && row.length === headers.length) {
                const obj = {};
                for (let j = 0; j < headers.length; j++) {
                  let d = row[j];
                  if (d.length > 0) {
                    if (d[0] === '"') d = d.substring(1, d.length - 1);
                    if (d[d.length - 1] === '"') d = d.substring(d.length - 2, 1);
                  }
                  if (headerChange[j]) {
                    obj[headerChange[j]] = d;
                  }
                }
                // remove the blank rows
                if (Object.values(obj).filter((x) => x).length > 0) {
                  list.push(obj);
                }
              }
            }
            if (list && list.length > 0) {
              let deviceData = [];
              list.forEach((number) => {
                let numberPrefix = getDialCodeByCountry(
                  this.props.countryStatesData,
                  number.numberCountryName
                );
                const numberObj = {
                  ...number,
                  phoneNumber:
                    number?.phoneNumber &&
                      number?.phoneNumber.length > 0 &&
                      numberPrefix &&
                      numberPrefix.length > 0
                      ? numberPrefix + number?.phoneNumber
                      : number?.phoneNumber,
                };
                deviceData.push(numberObj);
              });
              if (
                list.length <= VoiceAdminConstants.INVENTORY.NUMBER_FILE_MAXIMUM_ROWS
              ) {
                this.setState({ deviceList: deviceData });
              } else {
                await this.setState({ attachment: null, deviceList: [] });
                await this.setStateAsync({
                  errorMessage: IntlUtil.getText(
                    this._intl_ns_vpa_number_inventory,
                    "notification.error.devicesFileMaxRowsInvalid"
                  ),
                  showAlert: true,
                });
              }
            } else {
              await this.setState({ attachment: null, deviceList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.NumberCSVFileEmpty"
                ),
                showAlert: true,
              });
            }
          } else {
            if (columnRecordsCount.length >= 1) {
              await this.setState({ attachment: null, deviceList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.numberCSVColumnRecordsCount"
                ),
                showAlert: true,
              });
            } else if (columnOrder.length >= 1) {
              await this.setState({ attachment: null, deviceList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.numberCSVColumnOrder"
                ),
                showAlert: true,
              });
            } else {
              await this.setState({ attachment: null, deviceList: [] });
              await this.setStateAsync({
                errorMessage: IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "notification.error.deviceImportFailed"
                ),
                showAlert: true,
              });
            }
          }
        } else {
          await this.setState({ attachment: null, deviceList: [] });
          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.error.numberCSVColumnOrder"
            ),
            showAlert: true,
          });
        }
      }
    }
  };

  uploadNumberCsvFile = async () => {
    await this.props.showPageWaitDialog(
      IntlUtil.getText(
        this._intl_ns_vpa_number_inventory,
        "notification.info.pleaseWaitUpdatingData"
      )
    );
    const numObj = { numbers: this.state.numberList };
    uploadInventory(numObj, this._cancelToken)
      .then(async (res) => {
        if (
          res &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res.data &&
          res.data.result
        ) {
          await this.setState({ attachment: null, numberList: [] });
          await this.props.fetchNumbersData();
          await this.props.hidePageWaitDialog();
          await this.props.hideDialogBox();
          await this.setState({
            attachment: null,
            numberList: [],
            deviceList: [],
            selectedIndex: 0,
          });
        } else {
          await this.props.hidePageWaitDialog();
          await manageError(res, this.props.history);
        }
      })
      .catch(async (err) => {
        await this.props.hidePageWaitDialog();
        await this.setState({ attachment: null, numberList: [] });
        const errorStatus = ResponseUtil.getStatus(err);
        if (
          errorStatus &&
          errorStatus === AppConfigProps.httpStatusCode.badRequest
        ) {
          const primeError = ResponseUtil.getPrimeError(err);
          await this.setStateAsync({
            errorDetails: primeError.message,
          });
          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.error.numberImportFailed"
            ),
            showAlert: true,
          });
        } else {
          await manageError(err, this.props.history);
        }
      });
  };

  uploadDeviceCsvFile = async () => {
    await this.props.showPageWaitDialog(
      IntlUtil.getText(
        this._intl_ns_vpa_number_inventory,
        "notification.info.pleaseWaitUpdatingData"
      )
    );
    const devicesObj = { devices: this.state.deviceList };
    uploadDevices(devicesObj, this._cancelToken)
      .then(async (res) => {
        if (
          res &&
          res.status === AppConfigProps.httpStatusCode.ok &&
          res.data &&
          res.data.result
        ) {
          await this.setState({ attachment: null, deviceList: [] });
          await this.props.fetchNumbersData();
          await this.props.hidePageWaitDialog();
          await this.props.hideDialogBox();
          await this.setState({
            attachment: null,
            numberList: [],
            deviceList: [],
            selectedIndex: 0,
          });
        } else {
          await this.props.hidePageWaitDialog();
          await manageError(res, this.props.history);
        }
      })
      .catch(async (err) => {
        await this.props.hidePageWaitDialog();
        await this.setState({ attachment: null, deviceList: [] });
        const errorStatus = ResponseUtil.getStatus(err);
        if (
          errorStatus &&
          errorStatus === AppConfigProps.httpStatusCode.badRequest
        ) {
          const primeError = ResponseUtil.getPrimeError(err);
          await this.setStateAsync({
            errorDetails: primeError.message,
          });
          await this.setStateAsync({
            errorMessage: IntlUtil.getText(
              this._intl_ns_vpa_number_inventory,
              "notification.error.deviceImportFailed"
            ),
            showAlert: true,
          });
        } else {
          await manageError(err, this.props.history);
        }
      });
  };

  handleClearState = async (e, selected) => {
    if (selected.content === "Devices") {
      await this.clearAlert();
      await this.setState({ attachment: null, deviceList: [] });
    } else {
      await this.setState({ attachment: null, numberList: [] });
      await this.clearAlert();
    }
  };

  render() {
    return (
      <>
        {this.renderNumberImageDialog()}
        {this.renderDeciceImageDialog()}
        <Dialog
          className="vpa-dialog-Panel"
          header={
            <>
              <Text>
                {IntlUtil.getText(
                  this._intl_ns_vpa_number_inventory,
                  "content.import"
                )}
              </Text>
              <Divider size={1} />
            </>
          }
          content={
            <>
              <Menu
                accessibility={tabListBehavior}
                onActiveIndexChange={(e, item) => {
                  this.setState((prev, props) => {
                    return { ...prev, selectedIndex: item.activeIndex };
                  });
                }}
                onItemClick={(e, item) => {
                  this.handleClearState(e, item);
                }}
                activeIndex={this.state.selectedIndex}
                className="vpa-import-tabs m-b-10"
                primary
                underlined
                items={VoiceAdminConstants.INVENTORY.IMPORT}
              />
              {this.state.selectedIndex === 0 ? (
                <Grid className="page-grid p-l-0 p-r-0">
                  <Row className="m-l-0">
                    <Col>
                      <Text className="m-b-10">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.numberCsvFileInfoText"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row className="m-l-0 m-b-10 m-t-10">
                    <Col>
                      <Text
                        onClick={() =>
                          this.setState({ showImageNumberDialog: true })
                        }
                        className="vpa-dialog-info-text-link"
                        as="a"
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.numberInfoInstruction"
                        )}
                        color="brand"
                      />
                    </Col>
                  </Row>
                  <Row className="m-l-0 m-b-10 m-t-10">
                    <Col>
                      <Text
                        onClick={async () =>
                          await this.exportInventory()
                        }
                        className="vpa-dialog-info-text-link"
                        as="a"
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.downloadSampleFile"
                        )}
                        color="brand"
                      />
                    </Col>
                  </Row>
                  <Row className="m-l-0">
                    <Col>
                      <Flex column className="m-t-10 m-b-10">
                        <FormLabel
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_number_inventory,
                            "content.fileUpload"
                          )}
                        />
                        <Flex gap="gap.small">
                          <Input
                            value={this.state.attachment?.fileName}
                            type="text"
                            readOnly
                          />
                          <div className="vpa-import-file">
                            <Button
                              onClick={() => {
                                this.setState({
                                  attachment: null,
                                  numberList: [],
                                });
                                this.clearAlert();
                                this.handleFileUploadClick();
                              }}
                              text
                              icon={<LinkIcon />}
                              iconOnly
                            />
                            <input
                              id="importUserFile"
                              type="file"
                              accept=".csv"
                              onChange={(e) => {
                                e.persist();
                                this.importInventory(e);
                              }}
                              ref={this.showChooseFile}
                            />
                          </div>
                          {this.state.attachment?.fileName ? (
                            <Button
                              onClick={() => {
                                this.setState({
                                  attachment: null,
                                  numberList: [],
                                });
                                this.clearAlert();
                              }}
                              text
                              iconOnly
                              icon={<CloseIcon />}
                            />
                          ) : null}
                        </Flex>
                      </Flex>
                    </Col>
                  </Row>
                  {this.state.showAlert === true ? (
                    <Row className="m-l-0">
                      <Col>
                        {this.state.errorMessage ? (
                          <AlertErrorMessage
                            content={this.state.errorMessage}
                            moreDetails={{
                              label: IntlUtil.getText(
                                this._intl_ns_vpa_number_inventory,
                                "content.moreDetails"
                              ),
                              content: this.state.errorDetails,
                            }}
                          />
                        ) : null}
                      </Col>
                    </Row>
                  ) : null}
                </Grid>
              ) : (
                <Grid className="page-grid p-l-0 p-r-0">
                  <Row className="m-l-0">
                    <Col>
                      <Text className="m-b-10">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.deviceImportInfoText"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row className="m-l-0 m-b-10 m-t-10">
                    <Col>
                      <Text
                        onClick={() =>
                          this.setState({ showImageDeviceDialog: true })
                        }
                        className="vpa-dialog-info-text-link"
                        as="a"
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.numberInfoInstruction"
                        )}
                        color="brand"
                      />
                    </Col>
                  </Row>
                  <Row className="m-l-0 m-b-10 m-t-10">
                    <Col>
                      <Text
                        onClick={async () =>
                          await this.exportdevice()
                        }
                        className="vpa-dialog-info-text-link"
                        as="a"
                        content={IntlUtil.getText(
                          this._intl_ns_vpa_number_inventory,
                          "content.downloadSampleFile"
                        )}
                        color="brand"
                      />
                    </Col>
                  </Row>
                  <Row className="m-l-0">
                    <Col>
                      <Flex column className="m-t-10 m-b-10">
                        <FormLabel
                          content={IntlUtil.getText(
                            this._intl_ns_vpa_number_inventory,
                            "content.fileUpload"
                          )}
                        />
                        <Flex gap="gap.small">
                          <Input
                            value={this.state.attachment?.fileName}
                            type="text"
                            readOnly
                          />
                          <div className="vpa-import-file">
                            <Button
                              onClick={() => {
                                this.setState({
                                  attachment: null,
                                  deviceList: [],
                                });
                                this.clearAlert();
                                this.handleFileUploadClick();
                              }}
                              text
                              icon={<LinkIcon />}
                              iconOnly
                            />
                            <input
                              id="importUserFile"
                              type="file"
                              accept=".csv"
                              onChange={(e) => {
                                e.persist();
                                this.importDevices(e);
                              }}
                              ref={this.showChooseFile}
                            />
                          </div>
                          {this.state.attachment?.fileName ? (
                            <Button
                              onClick={() => {
                                this.setState({
                                  attachment: null,
                                  deviceList: [],
                                });
                                this.clearAlert();
                              }}
                              text
                              iconOnly
                              icon={<CloseIcon />}
                            />
                          ) : null}
                        </Flex>
                      </Flex>
                    </Col>
                  </Row>
                  {this.state.showAlert === true ? (
                    <Row className="m-l-0">
                      <Col>
                        {this.state.errorMessage ? (
                          <AlertErrorMessage
                            content={this.state.errorMessage}
                            moreDetails={{
                              label: IntlUtil.getText(
                                this._intl_ns_vpa_number_inventory,
                                "content.moreDetails"
                              ),
                              content: this.state.errorDetails,
                            }}
                          />
                        ) : null}
                      </Col>
                    </Row>
                  ) : null}
                </Grid>
              )}
            </>
          }
          footer={{
            children: () => {
              return (
                <Flex gap="gap.small">
                  {this.state.selectedIndex === 0 ? (
                    <Button
                      className="vpa-usn-button-sm"
                      disabled={this.state.numberList.length === 0}
                      onClick={() => this.uploadNumberCsvFile()}
                      primary
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_number_inventory,
                        "content.submit"
                      )}
                    />
                  ) : (
                    <Button
                      className="vpa-usn-button-sm"
                      disabled={this.state.deviceList.length === 0}
                      onClick={() => this.uploadDeviceCsvFile()}
                      primary
                      content={IntlUtil.getText(
                        this._intl_ns_vpa_number_inventory,
                        "content.submit"
                      )}
                    />
                  )}
                  <Button
                    onClick={() => {
                      this.setState({
                        attachment: null,
                        numberList: [],
                        deviceList: [],
                        selectedIndex: 0,
                      });
                      this.clearAlert();
                      this.props.hideDialogBox();
                    }}
                    content={IntlUtil.getText(
                      this._intl_ns_vpa_number_inventory,
                      "content.close"
                    )}
                  />
                </Flex>
              );
            },
          }}
          open={this.props.showDialogBox}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  countryStatesData: state.generalStore.countryStatesData,
});

const mapActionToProps = {
  showPageWaitDialog,
  hidePageWaitDialog,
};

export default connect(mapStateToProps, mapActionToProps)(NumberImport);
